import { render } from "./ProductosList.vue?vue&type=template&id=11f22855&scoped=true"
import script from "./ProductosList.vue?vue&type=script&lang=js"
export * from "./ProductosList.vue?vue&type=script&lang=js"

import "./ProductosList.vue?vue&type=style&index=0&id=11f22855&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f22855"]])

export default __exports__